export default __webpack_public_path__ + "static/media/vccircle.d79dacc6.png";